module.exports = __webpack_public_path__ + "static/media/proi-contabil.d8197484.webp";